import { ActionTree } from 'vuex'
import RootState from '@/store/RootState'
import { Auth } from "@/services/firebase/auth"
import { DB } from "@/services/firebase/db"
import Landlord from "@/types/landlord/landlord"
import LandlordState from "@/store/modules/landlord/LandlordState"

export const actions: ActionTree<LandlordState, RootState> = {
  storeLandlord ({ commit }, landlord: Landlord) {
    const currentUserId = Auth.currentUser?.uid
    if (!currentUserId) {
      return
    }
    return DB.collection('landlords').doc().set({
      createdAt: new Date(),
      userId: currentUserId,
      landlord: (Object.assign({}, landlord))
    })
  },
  getAllLandlords () {
    return DB.collection('landlords').where('userId', '==', Auth.currentUser?.uid).get()
      .then((query) => {
        const landLordData = query.docs.map((doc) => {
          if (doc.exists) return doc.data().landlord
        })
        return landLordData
      })
  }
}
